import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosConfig from '../../utils/axiosConfig';
import { resetProfile } from '../profile/profileSlice';
import { initialState } from './authSlice';

const AUTH_API_BASE_URL = '/admin/auth';
const USER_API_BASE_URL = '/admin/user';

export const loginUser = createAsyncThunk('user/login', async ({
	email, password
}, { rejectWithValue, dispatch }) => {
	try {
		const response = await axiosConfig.post(`${AUTH_API_BASE_URL}/email/login`, {
			email, 
			password
		});
		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const logoutUser = createAsyncThunk('user/logout', async (_, { rejectWithValue, dispatch }) => {
	try {
		const response = await axiosConfig.post(`${AUTH_API_BASE_URL}/logout`, {}, { skipAuthRefresh: true });
		dispatch(resetProfile());
		return response.data.message;

	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const updateUser = createAsyncThunk('user/update/me', async ({
	firstName, lastName, country, phone, avatarId, password
}, { rejectWithValue }) => {
	try {
		let data = {
			firstName, 
			lastName,
			country,
			phone,
			avatar: avatarId
		}
		if (password && password.trim() !== "") {
			data.password = password;
		}

		const response = await axiosConfig.post(`${USER_API_BASE_URL}/me`, data);
		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

const emailChangeError = (error) => {
	const msg = error.response?.data?.message;
	return Array.isArray(msg) ? msg.join(', ') : (msg || error.message);
};

export const requestUserEmailChange = createAsyncThunk(
	'user/email/change/request',
	async ({ email }, { rejectWithValue }) => {
		try {
			const response = await axiosConfig.post(`${USER_API_BASE_URL}/me/email/request`, {
				email: email.toLowerCase().trim(),
			});
			return response.data;
		} catch (error) {
			return rejectWithValue({ error: emailChangeError(error) });
		}
	},
);

export const confirmUserEmailChange = createAsyncThunk(
	'user/email/change/confirm',
	async ({ code }, { rejectWithValue }) => {
		try {
			const response = await axiosConfig.post(`${USER_API_BASE_URL}/me/email/confirm`, { code });
			return response.data;
		} catch (error) {
			return rejectWithValue({ error: emailChangeError(error) });
		}
	},
);

export const resendUserEmailChange = createAsyncThunk(
	'user/email/change/resend',
	async (_, { rejectWithValue }) => {
		try {
			const response = await axiosConfig.post(`${USER_API_BASE_URL}/me/email/resend`);
			return response.data;
		} catch (error) {
			return rejectWithValue({ error: emailChangeError(error) });
		}
	},
);

export const getSession = createAsyncThunk('user/session', async (_, { rejectWithValue, dispatch }) => {
	try {
		const response = await axiosConfig.post(`${AUTH_API_BASE_URL}/refresh`, {}, { skipAuthRefresh: true });
		if (!response) {
			return initialState;
		}
		return response.data;

	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const forgotPassword = createAsyncThunk('user/forgot/password', async ({
	email
}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${AUTH_API_BASE_URL}/forgot/password`, {
			email: email
		});

		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const resetPassword = createAsyncThunk('auth/reset/password', async ({
	email, code, password
}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${AUTH_API_BASE_URL}/forgot/password/reset`, {
			email,
			code,
			password
		});

		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const verifyForgotOtp = createAsyncThunk('user/forgot/otp/verify', async ({
	email, code
}, { rejectWithValue }) => {
	try {
		const response = await axiosConfig.post(`${AUTH_API_BASE_URL}/forgot/otp/verify`, {
			email,
			code
		});

		return response.data;
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});
